import React from 'react';

const LighteningIcon = () => {
  return (
    <svg
      width='44'
      height='44'
      viewBox='0 0 44 44'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        width='44'
        height='44'
        rx='5.33333'
        fill='#3B7CF4'
        fillOpacity='0.1'
      />
      <path
        d='M22.6641 15.3335V20.6668H27.3307L21.3307 28.6668V23.3335H16.6641L22.6641 15.3335Z'
        stroke='#3B7CF4'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LighteningIcon;
